import {
  VERIFY_EVENT_PAYMENT_REQUEST,
  VERIFY_EVENT_PAYMENT_SUCCESS,
  VERIFY_EVENT_PAYMENT_FAILURE,
  VERIFY_EVENT_PAYMENT_RESET,
} from "../../../types/event"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const verifyEventPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_EVENT_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        message: "",
        error: "",
        success: false,
      })
    case VERIFY_EVENT_PAYMENT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      })
    case VERIFY_EVENT_PAYMENT_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        message: "",
        error: action.payload.message || action.payload.error,
        success: false,
      })
    case VERIFY_EVENT_PAYMENT_RESET:
      return Object.assign({}, initialState)
    default:
      return state
  }
}

export default verifyEventPaymentReducer
